import { isBlank } from '@witmetrics/utils/strings';

export const classes = {
  dialog: 'w-[98vw] max-w-[500px] min-w-[200px] px-0',
  title: 'pb-3 pr-3 pl-6',
  body: 'px-6 w-full',
  form: 'w-full mb-2 flex flex-col gap-6',
  field: 'w-full',
  actions: 'px-6',
};

export function validateFields(email: string, password: string) {
  let fields: string[] = [];
  if (isBlank(email)) fields.push('email');
  if (isBlank(password)) fields.push('password');
  return fields;
}

export function isDisabled(email: string, password: string) {
  return isBlank(email) || isBlank(password);
}
